/**
 * Finetune suggestion table columns (per URL, inside accordion).
 */
const FinetuneContentAnalyticsColumns = [
  {
    title: 'No.',
    dataIndex: 'index',
    key: 'index',
    scopedSlots: { customRender: 'index' },
    width: 50
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: 'description',
    scopedSlots: { customRender: 'description' },
    width: 400
  },
  {
    title: 'Baseline Value',
    dataIndex: 'baselineValue',
    key: 'baselineValue',
    scopedSlots: { customRender: 'baselineValue' },
    width: 130
  },
  {
    title: 'Current Threshold',
    dataIndex: 'currentThreshold',
    key: 'currentThreshold',
    scopedSlots: { customRender: 'currentThreshold' },
    width: 150
  },
  {
    title: 'New Threshold',
    dataIndex: 'newThreshold',
    key: 'newThreshold',
    width: 120,
    scopedSlots: { customRender: 'newThreshold' }
  }
];

export { FinetuneContentAnalyticsColumns };
